import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';

import { Node } from '../../../../../api/table-of-content';
import { useMaterialLinkBuilder } from '../../../../../hooks/useMaterialLinkBuilder';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

interface NodeHierarchyBreadcrumbsProps {
  nodeHierarchy: Node[];
  size?: ComponentProps<typeof Breadcrumbs>['size'];
}

export default function NodeHierarchyBreadcrumbs({ nodeHierarchy, size = 'md' }: NodeHierarchyBreadcrumbsProps) {
  const { t } = useTranslation();
  const { buildMaterialTocLink } = useMaterialLinkBuilder();

  function getNodeTitle(node: Node, isLast: boolean) {
    if (isLast) {
      return (node.displayPrefix && node.prefix) || undefined;
    }

    return node.displayPrefix && node.prefix ? `${node.prefix} ${node.title}` : node.title;
  }

  return (
    <Breadcrumbs emphasized size={size} aria-label={t('PAGES.TOC_LEVEL.SIDEBAR.BREADCRUMB.A11Y_LABEL')}>
      {nodeHierarchy.map((node, index) => {
        const title = getNodeTitle(node, index === nodeHierarchy.length - 1);
        if (!title) return null;

        return (
          <Breadcrumbs.Item
            key={node.id}
            avatarImage={node.image ? <AvatarImage name={title} src={node.image} /> : undefined}
            to={buildMaterialTocLink(node.id) || ''}
          >
            {title}
          </Breadcrumbs.Item>
        );
      })}
    </Breadcrumbs>
  );
}
